if (!customElements.get('quick-filter-collection')) {
    class QuickFilterCollection extends HTMLElement {
        constructor() {
            super();

            this.sectionId = 'main-collection';
    
            this.selects = this.querySelectorAll(".heading-with-selects select");
            this.collectionValue = this.querySelector(".heading-with-selects select[name='collection']")?.value;
            this.filterValue = this.querySelector(".heading-with-selects select[name='filter']")?.value;

            this.productCards = this.querySelectorAll("product-form");

            this.init(); 
        }
    
        init() {
            this.selects.forEach((select) => {
                select.addEventListener('change', () => {
                    this.updateLabelandValue(select);
                    this.updateResults();
                });
            })
        }

        updateLabelandValue(select) {
            const label = select.parentElement.querySelector("label");
            const selectedOption = select.options[select.selectedIndex];
            const name = select.name;
            if (label) {
                label.textContent = selectedOption.text;
            } 
            if (name == 'collection'){
                this.collectionValue = select.value;
            } else {
                this.filterValue = select.value;
            }
        }

        async updateResults() {
            this.classList.add("__loading");

            const url = new URL(this.collectionValue, window.location.origin);

            const [key, value] = this.filterValue.split('=');
            url.searchParams.set(key, value);
            url.searchParams.set('sections', this.sectionId);

            const response = await fetch(url);
            const sections = await response.json();

            const sectionHTML = sections[this.sectionId];
            if (!sectionHTML) return;

            const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
            const newResults = doc.querySelectorAll('product-form');

            if (!newResults.length) {
                console.log("Oops, no results");
                return;
            }

            this.productCards.forEach((oldCard, i) => {
                if (!newResults[i]) return;
                oldCard.outerHTML = newResults[i].outerHTML;
            });

            this.classList.remove("__loading");
            this.productCards = this.querySelectorAll('product-form');
        }
    }

    customElements.define('quick-filter-collection', QuickFilterCollection);
}